import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal'

const DeleteModal = ({
  ctaFunction,
  isOpen,
  onHide,
  item,
  children,
  ctaButton = true,
  cancelButton = true,
  loading = false,
  dataPrivate = false,
  icon = 'triangle-exclamation',
  title = 'Are you sure you want to delete?',
  variant = 'danger',
  size = 'sm',
  ctaText = 'Delete'
}) => (
  <Modal
    ctaFunction={ctaFunction}
    isOpen={isOpen}
    onHide={onHide}
    icon={icon}
    title={title}
    ctaButton={ctaButton}
    cancelButton={cancelButton}
    loading={loading}
    variant={variant}
    size={size}
    ctaText={ctaText}
  >
    {dataPrivate
      ? item && <span>You are about to delete: <span className='fw-bold text-break' data-private>{item}. </span></span>
      : item && <span>You are about to delete: <span className='fw-bold text-break'>{item}. </span></span>
    }
    {children}
  </Modal>
)

DeleteModal.propTypes = {
  ctaFunction: PropTypes.func,
  isOpen: PropTypes.bool,
  onHide: PropTypes.func,
  item: PropTypes.any,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  ctaButton: PropTypes.bool,
  cancelButton: PropTypes.bool,
  loading: PropTypes.bool,
  dataPrivate: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  ctaText: PropTypes.string
}

export default DeleteModal
